var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87877 13.1218C3.16167 13.4047 3.62021 13.4047 3.90297 13.1218L7.99992 9.02486L12.0969 13.1218C12.3798 13.4047 12.8383 13.4047 13.1211 13.1218C13.404 12.8389 13.404 12.3804 13.1211 12.0976L9.02412 8.00065L13.1211 3.9037C13.404 3.62096 13.404 3.16226 13.1211 2.8795C12.8382 2.59659 12.3796 2.59659 12.0969 2.8795L7.99992 6.97645L3.90297 2.8795C3.62006 2.59659 3.16152 2.59676 2.87877 2.8795C2.59586 3.16241 2.59586 3.62095 2.87877 3.9037L6.97571 8.00065L2.87877 12.0976C2.59586 12.3805 2.59586 12.839 2.87877 13.1218V13.1218Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.4a106d71999d1d608770f8873fe364cf.svg";
export { ForwardRef as ReactComponent };